import { render, staticRenderFns } from "./Teen8.vue?vue&type=template&id=b641c72c&scoped=true&"
import script from "./Teen8.vue?vue&type=script&lang=js&"
export * from "./Teen8.vue?vue&type=script&lang=js&"
import style0 from "./Teen8.vue?vue&type=style&index=0&id=b641c72c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b641c72c",
  null
  
)

export default component.exports